import { z } from 'zod';

import { type ValidationMessageSet } from '../../form-validations';

export type EmailInput = { email: string };

const EMAIL_MAX = 80;

// Validation shared between client form & API payload
// Messages aren't needed for API payload validation
export const getEmailSchema = (messages?: ValidationMessageSet) =>
  z.object({
    email: z
      .string({ required_error: messages?.requiredMessage })
      .max(
        EMAIL_MAX,
        messages?.lengthMessage.replace('{max}', String(EMAIL_MAX))
      )
      .email(messages?.invalidMessage),
  });
